import { FC } from 'react'
import DivisionModal from '@modals/DivisionModal'
import ModalOnRoute from '@templates/ModalOnRoute'

const DivisionModalOnRoute: FC = () => {
  return <ModalOnRoute Component={DivisionModal} withoutCloseOnOutsideClick />
}

export default DivisionModalOnRoute
